import Vue from "vue";
import App from "./App.vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@/assets/styles/index.scss"; // global csss
import "@/assets/icons"; // icon
import VueI18n from "vue-i18n";
import BMap from "vue-baidu-map";

// 引入语言资源文件
import en from "./utils/lang/en.js";
import zh from "./utils/lang/zh.js";

import router from "./router/router.js"; // 导入路由配置
Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(BMap, {
  ak: "VIymLdMFKHCR0Y1UCPBkkxvJeXLAsrFS",
});
// 创建 VueI18n 实例
const i18n = new VueI18n({
  locale: "en", // 默认语言为英文
  messages: {
    en: en,
    zh: zh,
  },
});
new Vue({
  router, // 将路由配置传递给 Vue 实例
  render: (h) => h(App),
  i18n, // 将 i18n 实例注入到 Vue 实例中
}).$mount("#app");
